import React, { useState } from "react";
import Test from "../components/Test/TestDetails";
import Aside from "../modules/SideNav/Aside";

function AnnouncementSidenavLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <Test />
      {/* Liju */}
    </div>
  );
}

export default AnnouncementSidenavLayout;
